import styled from 'styled-components'
import { Button } from '@mui/material';

const ButtonSmall = styled(Button)`
  && {
    min-width: 0px;
  }
`

export { ButtonSmall }